import { ISydDocument } from 'models/shared.models'
import {
  IAccountingStepContinueButtonProps,
  TAccountStepFourValidationSteps,
} from 'models/accounting.models'
import {
  ACCOUNTING_PROCESS_STEPS,
  ACCOUNTING_STEP_FOUR_VALIDATION_STEPS,
} from 'lib/enums/accounting.enums'
import {
  checkforInvalidUploadContinue,
  getStepFourValidationConditionsAndSteps,
} from 'lib/utils/Accounting/accounting.utils'
import { useAccountingContext } from 'containers/Accounting/AccountingContainer/AccountingContainer'
import { IUseAccountingstepFour } from './useAccountingStepFour'
import { useCallback } from 'react'

interface IUseAccountingStepFourValidationStepsProps
  extends Pick<
    IUseAccountingstepFour,
    | 'fileStatuses'
    | 'filesToValidate'
    | 'totalFiles'
    | 'uploadedAndValidatedFiles'
    | 'uploadedFiles'
    | 'validFiles'
  > {
  invalidFiles: ISydDocument[]
}

interface IUseAccountingStepFourValidationSteps {
  continueButtonProps: IAccountingStepContinueButtonProps
}

const useAccountingStepFourValidationSteps = ({
  fileStatuses,
  filesToValidate,
  invalidFiles,
  totalFiles,
  uploadedAndValidatedFiles,
  uploadedFiles,
  validFiles,
}: IUseAccountingStepFourValidationStepsProps): IUseAccountingStepFourValidationSteps => {
  const { handleStepSubmit, runValidationServiceOnSelectedFiles } =
    useAccountingContext()

  const handleFilesSubmit = useCallback(() => {
    runValidationServiceOnSelectedFiles(
      ACCOUNTING_PROCESS_STEPS.SUBIDA_DOCUMENTOS_MULTIPLES,
      validFiles,
      invalidFiles,
      true,
      true
    )
  }, [invalidFiles, runValidationServiceOnSelectedFiles, validFiles])

  const validationConditionsAndSteps = getStepFourValidationConditionsAndSteps(
    totalFiles,
    uploadedFiles,
    filesToValidate,
    fileStatuses,
    uploadedAndValidatedFiles
  )

  const getValidationStep = (): TAccountStepFourValidationSteps => {
    for (const [condition, step] of validationConditionsAndSteps) {
      if (condition()) {
        return step
      }
    }
    return ACCOUNTING_STEP_FOUR_VALIDATION_STEPS.FILES_UPLOADED
  }

  const continueButtonPropsMap = {
    [ACCOUNTING_STEP_FOUR_VALIDATION_STEPS.FILES_UPLOADED]: {
      onClick: () =>
        handleStepSubmit(
          ACCOUNTING_PROCESS_STEPS.SUBIDA_DOCUMENTOS_MULTIPLES,
          '',
          uploadedFiles
        ),
      disabled: !totalFiles.length,
      text: 'Finalizar carga',
    },
    [ACCOUNTING_STEP_FOUR_VALIDATION_STEPS.FILES_VALIDATION]: {
      onClick: handleFilesSubmit,
      disabled: checkforInvalidUploadContinue(fileStatuses),
      text: 'Continuar',
    },
  }

  const step = getValidationStep()

  const continueButtonProps: IAccountingStepContinueButtonProps =
    continueButtonPropsMap[step]

  return {
    continueButtonProps,
  }
}

export default useAccountingStepFourValidationSteps
